import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import EmptyList from "../../components/ui/EmptyList";
import Workspace from "../../components/workspace";
import { sortRecordsByObjectProp } from "../../utils/stripEmptyObjectProp";
import { ServiceReport } from "./service-report";
import { ServiceReportComments } from "./service-report-comment-modal";
import { ServiceReportForm } from "./service-report-form";

const ServiceReports = ({ serviceReports = [] }) => {
   const [selected, setSelected] = useState({});
   const formModal = useDisclosure();
   const commentModal = useDisclosure();

   if (!serviceReports.length) return <EmptyList message="Service records would be listed here" />;
   return (
      <>
         <ServiceReportForm id={selected?.id} modal={formModal} setSelected={setSelected} />
         <ServiceReportComments serviceReport={selected} modal={commentModal} setSelectedReport={setSelected} />
         <Workspace.ListWrapper>
            {sortRecordsByObjectProp(serviceReports, "serviceDate", { desc: true }).map((_serviceReport, key) => (
               <ServiceReport
                  serviceReport={_serviceReport}
                  key={key}
                  setSelected={setSelected}
                  formModal={formModal}
                  commentModal={commentModal}
               />
            ))}
         </Workspace.ListWrapper>
      </>
   );
};

export { ServiceReports };
